import { FieldUsageEntities } from '../types';

const getFieldUsageCount = (fieldUsage: FieldUsageEntities | null) => {
  const fieldCountKeys = [
    'metrics',
    'savedFilters',
    'defaultDatasetFilters',
    'reports',
    'dashboards',
    'scorecards',
    'goals',
    'performanceBoards',
    'apps',
    'workspaces',
  ];
  if (!fieldUsage) return 0;

  return Object.keys(fieldUsage).reduce((acc, key) => {
    if (!fieldCountKeys.includes(key)) return acc;

    const value = fieldUsage[key as keyof FieldUsageEntities];
    if (Array.isArray(value)) {
      return acc + value.length;
    }
    return acc;
  }, 0);
};
export default getFieldUsageCount;
